module.exports = __webpack_public_path__ + "static/IMG-20200802-WA0071-9c434d5b4ae8c1d5d51da18b26a6ca16.jpg";